export default __webpack_public_path__ + "static/media/1822.698f63c2.png";